module.exports = __webpack_public_path__ + "static/media/bar_chart.35d5b58f.svg";